import * as yup from 'yup';
const CashAccountSchema = () =>
  yup.object({
    cashAccounts: yup.array().of(
      yup.object({
        currency: yup.string().required('Currency is required'),
        accountType: yup.string().required('Cash account type is required'),
      }),
    ),
  });

export default CashAccountSchema;
